import { getUserInfo } from '@/utils/bussiness';
import { ProjectRole } from '@/constants/role'
import { Label, Audit, Team, User, Notification } from '@/types'

export type UserState = {
  audits: Audit[]
  labels: Label[]
  notifications: Notification<any>[]
  seats: number
  usedSize: number
  storageSize: number
  aiRemains: number
  aiAccess: number
  currentTeam: Team | null
  currentRole: ProjectRole | null
  userInfo: User
}

export const userState: UserState = {
  seats: 0,
  labels: [],
  audits: [],
  usedSize: 0,
  storageSize: 0,
  aiRemains: 0,
  aiAccess: 0,
  notifications: [],
  currentTeam: null,
  userInfo: getUserInfo(),
  currentRole: null
}
